<template>
  <button
      class="timesheet_button"
      :disabled="adminBusy"
      @click="run"
      type="button"
  >
    <span v-if="!adminBusy">{{ hard ? 'Force ' : '' }}Reopen</span>
    <span v-else>Working...</span>
  </button>
</template>

<script>
export default {
  name: "AdminReopenTimesheetButton",

  props: {
    companyId: { required: true },
    timesheetId: { required: true },
    adminBusy: { type: Boolean, required: true },
    withAdminLock: { type: Function, required: true },
    success: { type: Function, required: true },
    hard: { type: Boolean, default: false }
  },

  methods: {
    async doAction() {
      let url = `${this.crmApiPath}r3/admin/timesheets/company/${this.companyId}/reopen/timesheet/${this.timesheetId}`;
      if (this.hard) {
        url += '?skip_fin=false';
      }
      await axios.post(url);
      this.$snotify?.success("Timesheet reopened!");
    },

    async run() {
      await this.withAdminLock(this.doAction)();
      await this.success();
    }
  }
};
</script>
